import { Injectable } from '@angular/core';

import { AirSilentBookingResourceService } from 'libraries/service/resources/airSilentBooking/airSilentBookingResource.service';
import { PostExtraService } from './post-extra.service';

import { IPostAirSearchRequest } from "libraries/interfaces/i-post-air-search-request";
import { IAirSilentBookingRequest } from "../../libraries/service/resources/model/booking/air/IAirSilentBookingRequest";
import { Observable } from 'rxjs';
import { IGetBookingsAirResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import {ISamAgent} from "../../libraries/service/resources/sam/ISamAgent";
import {ISamCompany} from "../../libraries/service/resources/sam/ISamCompany";
import {AgentAgencyService} from "./agent-agency.service";

@Injectable({
  providedIn: 'root'
})
export class SilentBookingService {

  constructor(
    private readonly airSilentBookingResourceService: AirSilentBookingResourceService,
    private readonly postExtraService: PostExtraService,
    private readonly agentAgencyService: AgentAgencyService
  ) { }

  public buildRequest(content: IPostAirSearchRequest, samAgent: ISamAgent, samCompany: ISamCompany): IAirSilentBookingRequest {
    return {
      content: {
          ...this.agentAgencyService.buildAgentAndAgency(samAgent, samCompany),
          ...content,
      },
      postExtra: this.postExtraService.getPostExtra()
    };
  }

  public createSilentBooking(request: IAirSilentBookingRequest, target: string): Observable<any> {
    return this.airSilentBookingResourceService.postSilentBooking(request, target);
  }
}
